import React from "react";
import {
  Modal,
  Table
} from "react-bootstrap";
import { stringDateTimeReceipt } from "../Utility/dateTime";
import { initialCheckOut, paymentNameMaps } from "../configs";
import { formatCurrency, summary } from "../Utility/function";
import { useTranslation } from 'react-i18next';
import { OneButton } from "../components";


function Modal_Receipt({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  data,
}) {
    const { t } = useTranslation();
    const { dateTime, receiptNumber, product, manualDiscount, moneyMustPaid, cashierName,
        rounding, pointDiscount, productDiscount, vatAmount = 0, payment, campaign } = {...initialCheckOut,...data};

    const { totalPrice, totalQty } = product.reduce(
      ( acc, item )=>{
        acc.totalPrice += item.net;
        acc.totalQty += item.qty;
        return acc
      },
      { totalPrice:0, totalQty:0 }
    )

  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      // size={size}
      fullscreen={true}
    >
       
      <Modal.Header closeButton>
        <h2><b>{t('mReceipt.receipt')}</b></h2>
      </Modal.Header>

      <Modal.Body  >
            <h6>วันที่ {stringDateTimeReceipt(dateTime)}</h6>
            <h6>เลขที่ใบเสร็จ : {receiptNumber}</h6>
            <h6>พนักงานขาย : {cashierName}</h6>
         
            <h6>จำนวน : {totalQty}</h6>
            <h6>ยอดขาย : {formatCurrency(totalPrice)||0}</h6>
            {campaign.map(({ name, discount })=>{
                    return <h6>{name} : {discount}</h6>
                    
            })}
            <h6>ส่วนลด กดลดมือ : {formatCurrency(manualDiscount) ||0}</h6>
            <h6>ส่วนลดสินค้า : {formatCurrency(productDiscount) ||0}</h6>
            <h6>ส่วนลดแลกแต้ม : {formatCurrency(pointDiscount.value) ||0}</h6>
            <h6>ปัดเศษ : {formatCurrency(rounding) ||0}</h6>
            <h6>ภาษีมูลค่าเพิ่ม : {formatCurrency(vatAmount)}</h6>
            <h6>ยอดสุทธิ : {formatCurrency(moneyMustPaid)}</h6>
            <h6>ประเภทการชำระ  : {payment.map(a=>a.name || paymentNameMaps[a.id]).join(',')}</h6>
            <h6>รับเงิน  : {formatCurrency(summary(payment,'amount')) ||0}</h6>
            <h6>เงินทอน : {formatCurrency(summary(payment,'change')) ||0}</h6>
                <React.Fragment>
                    <h4>รายการ</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >รายการ</th>
                          <th style={styles.text2} >จำนวน</th>
                          <th style={styles.text2} >ราคา</th>
                        </tr>
                      </thead>
                      <tbody  >
                        {product.map((item, index) => {
                            const { name, qty, net  } = item;
                            return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td style={styles.text2}>{name}</td>
                                    <td style={styles.text2}>{qty}</td>
                                    <td style={styles.text2}>{net}</td>
                                    </tr>
                        })}
                      </tbody>
                    </Table>
                </React.Fragment>
      </Modal.Body>
      <Modal.Footer>
        <OneButton {...{ text:'ปิด', submit:onHide, variant:'dark' }} />
    </Modal.Footer>
    </Modal>
  );
};

const styles = {
    text : {
      width:'5%',
      textAlign:'center',
      // maxWidth:'12px',
      minWidth:'2rem',
    },
    text2 : {
      width:'20%',
      textAlign:'center',
      minWidth:'120px'
    }
}

export default Modal_Receipt;
